module.exports = __webpack_public_path__ + "img/img-radiator-board.7ef78701.svg";